 
<div class="profile-container">
    <div class="">
        <div class="profile-content">

            <div class="personal-details">
              <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                      <input type="text" placeholder="search" (keyup.enter)="getProductStockByName()" [ngModelOptions]="{standalone: true}" [(ngModel)]="productSearch">
                    </form>
                    <i class="bi bi-search" (click)="getProductStockByName()"></i>
                  </div>
  
                  <div class="filter-icon">
                    <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                  </div>
                </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 10%;">{{ 'product-stock-info.tranId' | translate }}</th>
                        <th style="width: 15%;">{{ 'product-stock-info.tranDate' | translate }}</th>
                        <th style="width: 20%;">{{ 'product-stock-info.productName' | translate }}</th>
                        <th style="width: 20%;">{{ 'product-stock-info.branchName' | translate }}</th>
                        <th style="width: 10%;">{{ 'product-stock-info.drQty' | translate }}</th>
                        <th style="width: 10%;">{{ 'product-stock-info.crQty' | translate }}</th>
                        <th style="width: 15%;">{{ 'product-stock-info.balanceQty' | translate }}</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let x of stocks | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 10%;">{{x.tranId}}</p>
                      <p style="width: 15%;">{{x.tranDate | date}}</p>
                      <p style="width: 20%;" title="{{x.productName}}">{{x.productName}}</p>
                      <p style="width: 20%;" title="{{x.branchName}}">{{x.branchName}}</p>
                      <p style="width: 10%;text-align: center;">{{x.drQty | number: '1.2-2'}}</p>
                      <p style="width: 10%;text-align: center;">{{x.crQty | number: '1.2-2'}}</p>
                      <p style="width: 15%;text-align: center;">{{x.balanceQty | number: '1.2-2'}}</p>              
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && stocks.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
        </div>
    </div>
  </div>

